import * as React from 'react';
const PopupContext = React.createContext({
    hidePopup: () => { },
});
export const usePopupContext = () => {
    return React.useContext(PopupContext);
};
export default PopupContext;
